import React from "react";
import { useAuth } from "../context/auth";
import GuestbookInput from "./GuestbookInput";
import GuestbookEntry from "./GuestbookEntry";
import { useGuestbook } from "../context/guestbook";

export default function GuestbookPage() {
  const { currentUser } = useAuth();
  const { entries } = useGuestbook();

  return (
    <div
      style={{
        width: "100%",

        border: "1px outset rgb(212, 212, 212)",
        background: "rgba(145, 163, 237, 0.9)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        overflow: "scroll",
      }}
    >
      <div
        style={{
          width: "90%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <h1
          style={{
            fontSize: "24pt",
            fontStyle: "italic",
            fontWeight: "600",
            color: "rgba(19, 22, 75)",
            textAlign: "center",
          }}
        >
          Hotel Guest Book
        </h1>
        {currentUser && <GuestbookInput />}
        <div
          style={{
            width: "100%",
            background: "rgba(19, 22, 75, 0.4)",
          }}
        >
          <div
            style={{
              fontStyle: "italic",
              background: "rgba(19, 22, 75, 0.9)",
              color: "white",
              border: "5px outsetrgb(19, 22, 75)",
              padding: "5px",
              textAlign: "center",
              fontSize: "16pt",
            }}
          >
            ...Previous Guest's Entries...
          </div>
          {!entries.length && (
            <div style={{ padding: "25px", textAlign: "center" }}>
              No entries yet...
            </div>
          )}
          {entries
            .slice(0)
            .reverse()
            .map((entry, index) => (
              <GuestbookEntry key={index} entry={entry} />
            ))}
        </div>
      </div>
    </div>
  );
}
